/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
window.addEventListener('load', () => {
  setTimeout(() => {
    document.body.classList.remove('accordion-preload')
  }, 200)

  const accordions = Array.from(
    document.getElementsByClassName('wp-block-cai-blocks-accordion-group')
  )

  accordions.forEach((accordion) => {
    const items = Array.from(
      accordion.getElementsByClassName('wp-block-cai-blocks-accordion-item')
    )
    items.forEach((item) => {
      item.classList.remove('expanded')
      setAria(
        item.getElementsByClassName('cai-accordion-item__title')[0],
        'aria-expanded',
        'false'
      )

      item
        .getElementsByClassName('cai-accordion-item__title')[0]
        .addEventListener('click', () => {
          const expandedItems = Array.from(
            accordion.getElementsByClassName(
              'wp-block-cai-blocks-accordion-item expanded'
            )
          )

          let expanded = item.classList.contains('expanded')

          expandedItems.forEach((expandedItem) => {
            if (expandedItem !== item) {
              expandedItem.classList.remove('expanded')
              setAria(
                expandedItem.getElementsByClassName(
                  'cai-accordion-item__title'
                )[0],
                'aria-expanded',
                'false'
              )
            }
          })

          setAria(
            item.getElementsByClassName('cai-accordion-item__title')[0],
            'aria-expanded',
            expanded === true ? 'false' : 'true'
          )

          item.classList.toggle('expanded')
        })
    })
  })
})

const setAria = (element, property, value) => {
  return element.setAttribute(property, value)
}

/* eslint-enable no-console */
